export default {
  title: '请按要求标注下面一段语音。',
  invalidTask: '无效音频',
  role: '角色',
  STA: '背景持续噪音',
  NON: '突发的非语音类噪音',
  FIL: '无实际意义的语气词(本人)',
  RSP: '无实际意义的语气词(非本人)',
  SPK: '语音噪音',
  NPS: '非发音人发出的语音噪音',
  region: '选中区域：',
  please: '请输入内容',
  appNotify1: '请完成所有标注',
  appNotify2: '，至少有一段',
  appNotify3: '，保证起始位置在0.000',
  appNotify4: '，保证末尾位置在最后',
  add: '和',
  appNotify5: '首尾不相接',
  appNotify6: '段内容不完整',
  waveNotify1: '已经最大了',
  waveNotify2: '已经最小了',
  current: '当前',
  deafness: '听不清'
}



// WEBPACK FOOTER //
// ./src/lang/zh/task3Do.js